<template>
  <div>
    <FileUploader />
    <History />
  </div>
</template>

<script>
import FileUploader from "./fileUploader/Index";
import History from "./history/Index";

export default {
  components: {
    FileUploader,
    History,
  },
};
</script>
